import "bootstrap-daterangepicker/daterangepicker.css";
import React, { useContext, useEffect, useRef, useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import DateRangePicker from "react-bootstrap-daterangepicker";
import { AsyncTypeahead } from "react-bootstrap-typeahead";
import "react-calendar/dist/Calendar.css";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Select from "react-select";
import {
  getMasterData,
  getTodoList,
  getWatchlistNumber,
  modifyCharts,
  reallocateChartToAuditor,
  reallocateChartToCoder,
  selfAllocation,
  deleteCharts
} from "../../services/chartService";
import { chartHeaderIds, userRole } from "../../utils/constants";
import { imageIdGenerate } from "../../utils/custom";
import localStorageStore from "../../utils/localStorageStore";
import AuthContext from "../Auth/Middleware/AuthContext";
import CustomPagination from "../Manager/ManagerWorkLists/CustomPagination";
import ToDoColumnModifier from "./ToDoColumnModifier";
import "./coder.css";
import { saveNewChartInWorkList } from "../../services/managerWorkListService";

const ToDoList = ({ onQuery, setFilterForToDoList, filterForToDOList }) => {
  const auth = useContext(AuthContext);
  const routeLocation = useLocation();
  const navigate = useNavigate();
  const [process, setProcess] = useState([]);
  const [, setKey] = useState(0);
  const [location, setLocation] = useState([]);
  const [speciality, setSpeciality] = useState([]);
  const [primaryHealth, setPrimaryHealth] = useState([]);
  const [facility, setFacility] = useState([]);
  const [auditor, setAuditor] = useState([]);
  const [auditorSelected, setAuditorSelected] = useState(null);
  const [coderSelected, setCoderSelected] = useState(null);
  const [originalCoderSelected, setOriginalCoderSelected] = useState(null);
  const [milestone, setMilestone] = useState([]);
  const [qcStatus, setQcStatus] = useState([]);
  const [chartStatus, setChartStatus] = useState([]);
  const [holdReason, setHoldReason] = useState([]);
  const [commentClient, setCommentClient] = useState("");
  const [denialComment, setDenialComment] = useState("");
  const [deficiencyComment, setdeficiencyComment] = useState("");
  const [auditOption, setAuditOption] = useState([]);
  const [responsibleParties, setResponsibleParties] = useState([]);
  const [priority, setpriority] = useState("Critical");
  const critical = "Critical";
  const medium = "Medium";
  const low = "Low";
  const high = "High";
  const done = "Done";
  const [chartData, setChartData] = useState([]);
  const [inpval, setInputval] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [total, setTotal] = useState({});
  const [dateOfService, setDateOfService] = useState("");
  const [receivedDate, setReceivedDate] = useState("");
  const [dateOfCompletion, setDateOfCompletion] = useState("");
  const [loader, setLoader] = useState(false);
  const [noData, setNoData] = useState(false);
  const [priorities, setPriorities] = useState([]);
  const [coders, setCoder] = useState([]);
  const [codersSelected, setCodersSelected] = useState(null);
  const [coderFilter, setCoderFilter] = useState([]);
  const [originalCoderFilter, setOriginalCoderFilter] = useState([]);
  const [followUpCoderFilter, setFollowUpCoderFilter] = useState([]);
  const [allocatedUserFilter, setAllocatedUserfilter] = useState([]);
  const [coderDisabled, setCoderDisabled] = useState(true);
  const [coderAttending, setCoderAttending] = useState([]);
  const [allUsers, setAllUsers] = useState([]);
  const [auditorDisabled, setAuditorDisabled] = useState(true);
  const [allocationPriority, setAllocationPriority] = useState(null);
  const [defaultLocation, setDefaultLocation] = useState([]);
  const [defaultSpeciality, setDefaultSpeciality] = useState([]);
  const [defaultFacility, setDefaultFacility] = useState([]);
  const [defaultPrimaryHealth, setDefaultPrimaryHealth] = useState([]);
  const [defaultMilestone, setDefaultMilestone] = useState([]);
  const [defaultProcess, setDefaultProcess] = useState([]);
  const [auditorFilter, setAuditorFilter] = useState([]);
  const [defaultAuditorFilter, setDefaultAuditorFilter] = useState([]);
  const [defaultChartStatus, setDefaultChartStatus] = useState([]);
  const [defaultQcStatus, setDefaultQcStatus] = useState([]);
  const [defaultHoldReason, setDefaultHoldReason] = useState([]);
  const [defaultAuditOptions, setDefaultAuditOptions] = useState([]);
  const [defaultResponsibleParty, setDefaultResponsibleParty] = useState([]);
  const [serialNumberFrom, setSerialNumberFrom] = useState("");
  const [serialNumberTo, setSerialNumberTo] = useState("");
  const [filObj, setFilObj] = useState({});
  const [filterPagination, setFilterPagination] = useState(false);
  const [localDataLoaded, setLocalDataLoaded] = useState(false);
  const [optionsWorklist, setOptionsWorklist] = useState([]);
  const [optionsChart, setOptionsChart] = useState([]);
  const [selectedOptionWorkList, setSelectedOptionWorkList] = useState([]);
  const [selectedOptionWorkListActual, setSelectedOptionWorkListActual] =
    useState([]);
  const [selectedOptionChartRender, setSelectedOptionChartRender] = useState(
    [],
  );
  const [selectedOptionChart, setSelectedOptionsChart] = useState(routeLocation?.state?.submitData?.chart_no ?? "");
  const isLoading = false;
  const typeaheadRef = useRef(null);
  const typeheadRefChart = useRef(null);
  const [reallocate, setReallocate] = useState();
  const ignoreDiacritics = true;
  const [originalAuditorFilter, setDefaultOriginalAuditorFilter] = useState([]);
  const [fllowUpAuditorFilter, setDefaultFollowUpAuditorFilter] = useState([]);
  const [globalChartSearch, setGlobalChartSearch] = useState({});
  const [resetForm, setResetForm] = useState(false);
  const paginate = (pageNumber) => setCurrentPage(pageNumber);
  const [sortConfig, setSortConfig] = useState({
    sort_column: "MilestoneId",
    sort_direction: "ASC",
  });
  const [chartHeaders, setChartHeaders] = useState({});
  const [localFilterData, setLocalFilterData] = useState({});
  const [allSelectLoaded, setAllSelectLoaded] = useState(false);
  const showTableView = localStorage.getItem("attending") === "true";
  const [subSpeciality, setSubSpeciality] = useState([]);
  const [defaultSubSpeciality, setDefaultSubSpeciality] = useState([]);
  const [selectedNewChartWorkListActual, setSelectedNewChartWorkListActual] = useState([]);
  const [dateOfAuditorAllocation, setDateOfAuditorAllocation] = useState("");
  const [dateOfCoderAllocation, setDateOfCoderAllocation] = useState("");

  let filterObj = {};

  useEffect(() => {
    const chartHeaders = localStorage.getItem("valerion_chart_headers");
    if (!chartHeaders) {
      initializeHeaders();
      return;
    }

    try {
      const chartHeaderVal = JSON.parse(chartHeaders);
      setChartHeaders(chartHeaderVal);
    } catch (e) {
      initializeHeaders();
    }
  }, []);

  useEffect(() => {
    fetchMasterData();
    const filterValues = localStorageStore.getFilterValues();

    if (filterValues) {
      const filterValuesJson = JSON.parse(filterValues);
      setFilterValuesFromLocalStorage(filterValuesJson);
    } else {
      setLocalDataLoaded(true);
    }
  }, []);

  useEffect(() => {
    if (showTableView === true && allSelectLoaded && localDataLoaded) {
      fetchTodoList(priority, pageSize, currentPage);
    }
    
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ auth.globalClientId?.value, auth.globalLocationId?.value, pageSize, priority, currentPage, filterPagination, filObj, showTableView, reallocate,
    sortConfig.sort_column, sortConfig.sort_direction, localDataLoaded, allSelectLoaded,
  ]);

  const filterSubmit = async (type, globalTriggering = false) => {
    setInputval(() => {
      return {
        ...inpval,
      };
    });

    setLoader(true);
    if (type !== "reset") {
      filterObj = {
        ...inpval,
        date_of_service: dateOfService,
        received_date: receivedDate,
        completion_date: dateOfCompletion,
        date_of_auditor_allocation: dateOfAuditorAllocation,
        date_of_coder_allocation: dateOfCoderAllocation,
        location:
          defaultLocation?.length !== 0
            ? defaultLocation?.map((item) => item.value)
            : "",
        processid:
          defaultProcess?.length !== 0
            ? defaultProcess?.map((item) => item.value)
            : "",
        specialty:
          defaultSpeciality?.length !== 0
            ? defaultSpeciality?.map((item) => item.value)
            : "",
        facility:
          defaultFacility?.length !== 0
            ? defaultFacility?.map((item) => item.value)
            : "",
        primary_health:
          defaultPrimaryHealth?.length !== 0
            ? defaultPrimaryHealth?.map((item) => item.value)
            : "",
        milestone:
          defaultMilestone?.length !== 0
            ? defaultMilestone?.map((item) => item.value)
            : "",
        latest_coder:
          coderFilter?.length !== 0
            ? coderFilter?.map((item) => item.value)
            : "",
        latest_auditor:
          defaultAuditorFilter?.length !== 0
            ? defaultAuditorFilter?.map((item) => item.value)
            : "",
        coder_comments: commentClient,
        denial_comments: denialComment,
        deficiency_comments: deficiencyComment,
        qc_status_id:
          defaultQcStatus?.length !== 0
            ? defaultQcStatus?.map((item) => item.value)
            : "",
        chart_status:
          defaultChartStatus?.length !== 0
            ? defaultChartStatus?.map((item) => item.value)
            : "",
        audit_options:
          defaultAuditOptions?.length !== 0
            ? defaultAuditOptions?.map((item) => item.value)
            : "",
        hold_reasons:
          defaultHoldReason?.length !== 0
            ? defaultHoldReason?.map((item) => item.value)
            : "",
        s_no_from:
          serialNumberFrom === "" || serialNumberFrom === undefined
            ? routeLocation?.state?.s_no_from
            : serialNumberFrom,
        s_no_to:
          serialNumberTo === "" || serialNumberTo === undefined
            ? routeLocation?.state?.s_no_to
            : serialNumberTo,
        worklist_number:
          selectedOptionWorkList?.length === 0
            ? routeLocation?.state?.worklist_number
            : selectedOptionWorkList,
        chart_no: selectedOptionChart || "",
        original_coder:
          originalCoderFilter?.length !== 0
            ? originalCoderFilter?.map((item) => item.value)
            : "",
        follow_up_coder:
          followUpCoderFilter?.length !== 0
            ? followUpCoderFilter?.map((item) => item.value)
            : "",
        UserId:
          allocatedUserFilter?.length !== 0
            ? allocatedUserFilter?.map((item) => item.value)
            : "",
        original_auditor:
          originalAuditorFilter?.length !== 0
            ? originalAuditorFilter?.map((item) => item.value)
            : "",
        follow_up_auditor:
          fllowUpAuditorFilter?.length !== 0
            ? fllowUpAuditorFilter?.map((item) => item.value)
            : "",
        subSpecialty:
          defaultSubSpeciality?.length !== 0
            ? defaultSubSpeciality?.map((item) => item.value)
            : "",
        responsibleParties:
          defaultResponsibleParty?.length !== 0
            ? defaultResponsibleParty?.map((item) => item.value)
            : "",
      };
      if (globalTriggering) {
        if (
          globalChartSearch.hasOwnProperty("dateOfService") &&
          filterObj.date_of_service === "" &&
          !resetForm
        ) {
          filterObj.date_of_service = globalChartSearch.dateOfService;
        }
        if (
          globalChartSearch.hasOwnProperty("receivedDate") &&
          filterObj.received_date === "" &&
          !resetForm
        ) {
          filterObj.received_date = globalChartSearch.receivedDate;
        }
        if (
          globalChartSearch.hasOwnProperty("dateOfCompletion") &&
          filterObj.completion_date === "" &&
          !resetForm
        ) {
          filterObj.completion_date = globalChartSearch.dateOfCompletion;
        }
        if (
          globalChartSearch.hasOwnProperty("selectedOptionChart") &&
          filterObj.chart_no === "" &&
          !resetForm
        ) {
          filterObj.chart_no = globalChartSearch.selectedOptionChart;
        }
      }
      saveFilterDataToLocal(filterObj);
    } else {
      navigate("/", { state: {} });
      setSelectedOptionChartRender();
      setSelectedOptionWorkListActual();
    }
    setFilObj(filterObj);
    // setFilterPagination(true);
    setFilterForToDoList(filterObj);
  };

  const chartListFilterButton = document.querySelector(
    "#chart_list_filter_button",
  );

  const setMenuStaticProperty = (isStatic) => {
    if (!isStatic) {
      setTimeout(() => {
        chartListFilterButton?.setAttribute("data-kt-menu-static", isStatic);
      }, 500);
    } else {
      chartListFilterButton?.setAttribute("data-kt-menu-static", isStatic);
    }
  };

  const setFilterValuesFromLocalStorage = (data) => {
    setLocalFilterData(data);
    setSerialNumberFrom(data.s_no_from);
    setSerialNumberTo(data.s_no_to);
  };

  const initializeHeaders = () => {
    const headersToHide = ["follow_up_auditor"];
    const headers = { ...chartHeaderIds };
    Object.keys(headers).forEach((i) => {
      if (headersToHide.includes(i)) {
        headers[i] = false;
      } else {
        headers[i] = true;
      }
    });

    setChartHeaders(headers);
  };

  const handleSearchWorkList = async (query) => {
    let postData = {
      worklist_no: query,
      chart_no: "",
    };

    const items = await getWatchlistNumber(postData);
    const workList = items?.data?.typeaheadWorkListRecord;
    setOptionsWorklist(workList);
    setSelectedOptionWorkList(query);
  };

  const handleSearchChart = async (query) => {
    let postData = {
      worklist_no: "",
      chart_no: query,
    };
    const items = await getWatchlistNumber(postData);
    const chart = items?.data?.typeaheadChartRecord;
    setOptionsChart(chart);
    setSelectedOptionsChart(query);
  };

  const isFilterEmpty = (filterObj) => {
    return Object.values(filterObj).every((value) => {
      if (typeof value === "string") {
        return !value;
      }

      if (Array.isArray(value)) {
        return !value.length;
      }

      return !value;
    });
  };

  const saveFilterDataToLocal = (currentFilterSettings) => {
    if (
      currentFilterSettings &&
      Object.keys(currentFilterSettings).length > 0
    ) {
      let oldFilters = localStorageStore.getFilterValues() ?? {};
      if (oldFilters) {
        oldFilters = JSON.parse(oldFilters);
        if (oldFilters.actualWorkList) {
          currentFilterSettings.actualWorkList = oldFilters.actualWorkList;
          currentFilterSettings.chartRender = oldFilters.chartRender;
        }
      }
      if (!isFilterEmpty(currentFilterSettings)) {
        localStorageStore.setFilterValues(
          JSON.stringify(currentFilterSettings),
        );
      }
    }
  };

  const fetchTodoList = async (priority, pageSize, currentPage) => {
    let response;

    if (filterPagination === true) {
      setCurrentPage(1);
      setFilterPagination(false);
    }

    setLoader(true);

    const region = {
      client: auth.globalClientId?.value,
      location: auth.globalLocationId?.value
    };

    if (
      (serialNumberFrom === "" || serialNumberFrom === undefined) &&
      (serialNumberTo === "" || serialNumberTo === undefined) &&
      selectedOptionWorkList?.length === 0
    ) {
      filObj.worklist_number = [routeLocation?.state?.worklist_number];
      filObj.s_no_from = routeLocation?.state?.s_no_from;
      filObj.s_no_to = routeLocation?.state?.s_no_to;
      filObj[routeLocation?.state?.role] = [routeLocation?.state?.id];

      response = await getTodoList(priority, pageSize, currentPage, {
        ...filObj,
        ...sortConfig,
      }, region);
    } else {
      response = await getTodoList(priority, pageSize, currentPage, {
        ...filObj,
        ...sortConfig,
      }, region);
    }

    if (response?.charts.length === 0) {
      setNoData(true);
    } else {
      setNoData(false);
    }
    setLoader(false);
    setChartData(response?.charts);
    setTotal(response?.counts);
    window.KTMenu.init();
  };

  useEffect(() => {}, [chartData]);
  const handleLinkClick = (id) => {
    const chartIdMap = chartData.map(({ Id }) => Id);
    localStorage.setItem("chartIdMap", JSON.stringify(chartIdMap));
    navigate(`/process-chart/${id}`);
  };

  const handleAllocateAuditor = (event) => {
    setAuditorSelected(event);
    setTimeout(() => {
      document.querySelector("button.reallocate-btn").dispatchEvent(
        new MouseEvent("click", {
          view: window,
          bubbles: true,
          cancelable: true,
          buttons: 1,
        }),
      );
    }, 10);
  };

  const handleAllocateCoder = (event) => {
    setCoderSelected(event);
    setTimeout(() => {
      document.querySelector("button.reallocate-btn").dispatchEvent(
        new MouseEvent("click", {
          view: window,
          bubbles: true,
          cancelable: true,
          buttons: 1,
        }),
      );
    }, 10);
  };

  const handleReallocateClick = () => {
    let chartIds = [];
    document
      .querySelectorAll("input[type=checkbox].action-checkbox:checked")
      .forEach((el) => {
        chartIds.push(el.getAttribute("data-chart-id"));
      });
    chartIds = chartIds.filter(Number);
    if (chartIds.length === 0) {
      window.toastr.error("No chart selected for reallocation!");
    } else {
      let postData = {
        ChartIds: chartIds.filter(Number),
        AuditorId: auditorSelected.value,
      };
      reallocateChartToAuditor(postData)
        .then((response) => {
          if (response?.success) {
            window.toastr.success(response?.message);
            setReallocate(response);
            let inputs = document.querySelector(".action-checkbox");
            inputs.checked = false;
          } else {
            window.toastr.error(response?.message);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
    setAuditorSelected(null);
  };

  const handleReallocateCoderClick = () => {
    let chartIds = [];
    document
      .querySelectorAll("input[type=checkbox].action-checkbox:checked")
      .forEach((el) => {
        chartIds.push(el.getAttribute("data-chart-id"));
      });
    chartIds = chartIds.filter(Number);
    if (chartIds.length === 0) {
      window.toastr.error("No chart selected for reallocation!");
    } else {
      let postData = {
        ChartIds: chartIds.filter(Number),
        CoderId: coderSelected.value,
      };
      reallocateChartToCoder(postData)
        .then((response) => {
          if (response?.success) {
            window.toastr.success(response?.message);
            setReallocate(response);
            let inputs = document.querySelector(".action-checkbox");
            inputs.checked = false;
          } else {
            window.toastr.error(response?.message);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
    setCoderSelected(null);
  };

  const handleSelfAllocatedChart = () => {
    let chart_id = [];
    document
      .querySelectorAll("input[type=checkbox].action-checkbox:checked")
      .forEach((el) => {
        chart_id.push(el.getAttribute("data-chart-id"));
      });
    chart_id = chart_id.filter(Number);
    const userRole = localStorage.getItem("Role");
    if (chart_id.length === 0) {
      window.toastr.error("No chart selected for selfAllocation!");
    } else {
      let postData = {
        chart_id: chart_id.filter(Number),
        userRole: userRole,
      };
      selfAllocation(postData)
        .then((response) => {
          if (response?.success) {
            window.toastr.success(response?.message);
            onQuery(response);
            setReallocate(response);
            unCheck();
          } else {
            window.toastr.error(response?.message);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  const renderAuditorList = () => {
    return auditor?.map((data) => ({
      label: `${data.name}`,
      value: data.id,
    }));
  };

  const renderCoderList = () => {
    return coderAttending?.map((data) => ({
      label: `${data.name}`,
      value: data.id,
    }));
  };

  const renderCoderFilter = () => {
    return coders?.map((data) => ({
      label: data.name,
      value: data.id,
    }));
  };

  const renderAllocatedUserFilter = () => {
    return allUsers?.map((data) => ({
      label: `${data.first_name} ${data.last_name}`,
      value: data.id,
    }));
  };

  const renderAuditorFilterList = () => {
    return auditorFilter?.map((data) => ({
      label: data.name,
      value: data.id,
    }));
  };

  const handleRadioCoder = () => {
    setCoderDisabled(false);
    setAuditorDisabled(true);
    setAuditorSelected(null);
    setOriginalCoderSelected(null);
  };

  const handleRadioAuditor = () => {
    setAuditorDisabled(false);
    setCoderDisabled(true);
    setCodersSelected(null);
    setOriginalCoderSelected(null);
  };

  const handleAllocateToAuditor = (event) => {
    setAuditorSelected(event);
    handleMenu();
  };
  const handleRadioOriginalCoder = (event) => {
    setOriginalCoderSelected(true);
    setAuditorDisabled(true);
    setCoderDisabled(true);
    handleMenu();
  };

  const handleReallocateCoder = (event) => {
    setCodersSelected(event);
    handleMenu();
  };

  const handleCoderFilter = (event) => {
    setCoderFilter(event);
    triggerFilterOpen();
  };

  const handleOriginalCoderFilter = (event) => {
    setOriginalCoderFilter(event);
    triggerFilterOpen();
  };

  const handleFollowUpCoderFilter = (event) => {
    setFollowUpCoderFilter(event);
    triggerFilterOpen();
  };

  const handleAllocatedUserFilter = (event) => {
    setAllocatedUserfilter(event);
    triggerFilterOpen();
  };

  const handleMenu = () => {
    setTimeout(() => {
      document.querySelector("button.modify-btn").dispatchEvent(
        new MouseEvent("click", {
          view: window,
          bubbles: true,
          cancelable: true,
          buttons: 1,
        }),
      );
    }, 10);
  };

  const handleAddChartMenu = () => {
    setTimeout(() => {
      document.querySelector("button.add-btn").dispatchEvent(
        new MouseEvent("click", {
          view: window,
          bubbles: true,
          cancelable: true,
          buttons: 1,
        }),
      );
    }, 10);
  };

  const triggerFilterOpen = () => {
    setTimeout(() => {
      document.querySelector("button.btn-filter").dispatchEvent(
        new MouseEvent("click", {
          view: window,
          bubbles: true,
          cancelable: true,
          buttons: 1,
        }),
      );
    }, 10);
  };

  const handleCheckBoxChange = () => {
    setTimeout(() => {
      const selectedChartsCount = document.querySelectorAll(
        "input[type=checkbox].action-checkbox.chart-checks:checked",
      ).length;
      const selectedChartsCountElement = document.querySelectorAll(
        ".selected-charts-count",
      );

      if (selectedChartsCountElement.length) {
        selectedChartsCountElement.forEach((selectedChartsCountElement) => {
          selectedChartsCountElement.innerHTML =
            selectedChartsCount + " Selected";
        });
      }
    }, 200);
  };

const handleChartSelection = () => {
  const selectedChartsCount = document.querySelectorAll(
    "input[type=checkbox].action-checkbox.chart-checks:checked"
  ).length;

  if (selectedChartsCount > 0) {
    let chartIds = [];
    document
      .querySelectorAll("input[type=checkbox].action-checkbox:checked")
      .forEach((el) => {
        chartIds.push(el.getAttribute("data-chart-id"));
      });
    chartIds = chartIds.filter(Number);

    if (chartIds.length > 0) {
      return chartIds;
    } else {
      window.toastr.error("No valid chart IDs found!");
      return null;
    }
  } else {
    window.toastr.error("No charts selected for modification!");
    return null;
  }
};

const handleResponseAndUpdateUI = (response) => {
  if (response?.success) {
    window.toastr.success(response?.message);
    setReallocate(response);

    document.getElementById("allocationpriority").value = "";
    ["flexRadioDefault1", "flexRadioDefault2", "flexRadioDefault3"].forEach(
      (id) => {
        const element = document.getElementById(id);
        if (element) {
          element.checked = false;
        }
      }
    );
    setAllocationPriority(null);
    setCoderDisabled(true);
    setAuditorDisabled(true);
    setCodersSelected([]);
    setAuditorSelected([]);
    setOriginalCoderSelected([]);
    document.querySelector(".selected-charts-count").innerHTML =
      0 + " Selected";
    document.querySelector(".action-checkbox").checked = false;
  } else {
    window.toastr.error(response?.message);
  }
};

const reallocateSelectedCharts = () => {
  const chartIds = handleChartSelection();

  if (chartIds && allocationPriority && (codersSelected || auditorSelected || originalCoderSelected)) {
    let postData = {
      ChartId: chartIds,
      PriorityId: allocationPriority,
      coder: codersSelected?.value || null,
      auditor: auditorSelected?.value || null,
      originalCoder: originalCoderSelected || null,
    };

    modifyCharts(postData)
      .then(handleResponseAndUpdateUI)
      .catch((error) => {
        window.toastr.error(error);
      });
  } else {
    window.toastr.error("Please select desired priority and user for the chart(s)");
  }
};

const deleteSelectedCharts = () => {
  const chartIds = handleChartSelection();

  if (chartIds) {
    let postData = { ChartId: chartIds };

    deleteCharts(postData)
      .then(handleResponseAndUpdateUI)
      .catch((error) => {
        window.toastr.error(error);
      });
  } else {
    window.toastr.error("Please select the chart(s)");
  }
};

  const reallocateSelectedChartsReset = () => {
    document.getElementById("allocationpriority").value = "";
    document.getElementById("flexRadioDefault1").checked = false;
    document.getElementById("flexRadioDefault2").checked = false;
    setAllocationPriority(null);
    setCoderDisabled(true);
    setAuditorDisabled(true);
    setCodersSelected([]);
    setAuditorSelected([]);
    setOriginalCoderSelected([]);
    setTimeout(() => {
      document.querySelector("button.modify-btn").dispatchEvent(
        new MouseEvent("click", {
          view: window,
          bubbles: true,
          cancelable: true,
          buttons: 1,
        }),
      );
    }, 10);
    unCheck();
    let inputs = document.querySelector(".action-checkbox");
    inputs.checked = false;
  };

  function unCheck() {
    var x = document.getElementsByClassName("checkbox-row");
    for (let i = 0; i < x.length; i++) {
      if (x[i].checked !== undefined) {
        x[i].checked = false;
      }
    }
    handleCheckBoxChange();
  }

  const toggleSort = (column) => {
    setSortConfig({
      sort_column: column,
      sort_direction: sortConfig.sort_direction === "ASC" ? "DESC" : "ASC",
    });
  };

  const renderSortIcon = (columnKey) => {
    if (sortConfig.sort_column === columnKey) {
      return sortConfig.sort_direction === "ASC"
        ? "fa fa-sort-up"
        : "fa fa-sort-down";
    } else {
      return "fa fa-sort";
    }
  };

  const showTable = (value) => {
    return chartData?.map((row) => (
      <tr key={row?.Id}>
        <td>
          <div className="form-check form-check-sm form-check-custom form-check-solid">
            <input
              className="form-check-input action-checkbox chart-checks checkbox-row"
              onChange={handleCheckBoxChange}
              data-chart-id={row?.Id}
              type="checkbox"
              value="1"
              name="reallocateChartIds[]"
            />
          </div>
        </td>
        <td onClick={() => handleLinkClick(row?.Id)}>
          <strong className="text-gray-900">{row?.Worklist}</strong>
        </td>
        <td
          onClick={() => handleLinkClick(row?.Id)}
          className="link-selection-color"
          style={{ cursor: "pointer" }}
        >
          {row?.SNo}
        </td>
        {chartHeaders["Client"] && <td>{row?.Client}</td>}
        {chartHeaders["Location"] && <td>{row?.Location}</td>}
        {chartHeaders["Specialty"] && <td>{row?.Specialty}</td>}
        {chartHeaders["chart_no"] && (
          <td
            onClick={() => handleLinkClick(row?.Id)}
            className="link-selection-color"
            style={{ cursor: "pointer" }}
          >
            {row?.chart_no}
          </td>
        )}
        {chartHeaders["DateOfService"] && <td>{row?.DateOfService}</td>}
        {chartHeaders["original_coder"] && (
          <td>
            {row?.original_coder?.id ? (
              <div className="symbol-group symbol-hover flex-nowrap">
                <OverlayTrigger
                  overlay={<Tooltip>{row?.original_coder?.name}</Tooltip>}
                  key={row?.original_coder?.id}
                  placement={"right"}
                >
                  <div
                    className="symbol symbol-35px symbol-circle user-image"
                    data-kt-initialized="1"
                  >
                    <img
                      alt="name"
                      src={
                        row?.original_coder?.image_url ??
                        `../assets/media/avatars/300-${imageIdGenerate(
                          row?.original_coder?.id,
                        )}.jpg`
                      }
                    />
                  </div>
                </OverlayTrigger>
              </div>
            ) : (
              ""
            )}
          </td>
        )}
        {chartHeaders["follow_up_coder"] && (
          <td>
            {row?.follow_up_coder?.id ? (
              <div className="symbol-group symbol-hover flex-nowrap">
                <OverlayTrigger
                  overlay={<Tooltip>{row?.follow_up_coder?.name}</Tooltip>}
                  key={row?.follow_up_coder?.id}
                  placement={"right"}
                >
                  <div
                    className="symbol symbol-35px symbol-circle user-image"
                    data-kt-initialized="1"
                  >
                    <img
                      alt="name"
                      src={
                        row?.follow_up_coder?.image_url ??
                        `../assets/media/avatars/300-${imageIdGenerate(
                          row?.follow_up_coder?.id,
                        )}.jpg`
                      }
                    />
                  </div>
                </OverlayTrigger>
              </div>
            ) : (
              ""
            )}
          </td>
        )}

        {chartHeaders["original_auditor"] && (
          <td>
            {row?.original_auditor?.id ? (
              <div className="symbol-group symbol-hover flex-nowrap">
                <OverlayTrigger
                  overlay={<Tooltip>{row?.original_auditor?.name}</Tooltip>}
                  key={row?.original_auditor?.id}
                  placement={"right"}
                >
                  <div
                    className="symbol symbol-35px symbol-circle user-image"
                    data-kt-initialized="1"
                  >
                    <img
                      alt="name"
                      src={
                        row?.original_auditor?.image_url ??
                        `../assets/media/avatars/300-${imageIdGenerate(
                          row?.original_auditor?.id,
                        )}.jpg`
                      }
                    />
                  </div>
                </OverlayTrigger>
              </div>
            ) : (
              ""
            )}
          </td>
        )}
        {chartHeaders["UserId"] && (
          <td>
            {row?.UserId ? (
              <div className="symbol-group symbol-hover flex-nowrap">
                <OverlayTrigger
                  overlay={
                    <Tooltip>{`${row?.UserFirstName} ${row?.UserLastName}`}</Tooltip>
                  }
                  key={row?.UserId}
                  placement={"right"}
                >
                  <div
                    className="symbol symbol-35px symbol-circle user-image"
                    data-kt-initialized="1"
                  >
                    <img
                      alt="name"
                      src={
                        row?.UserImageUrl ??
                        `../assets/media/avatars/300-${imageIdGenerate(
                          row?.UserId,
                        )}.jpg`
                      }
                    />
                  </div>
                </OverlayTrigger>
              </div>
            ) : (
              ""
            )}
          </td>
        )}
        {chartHeaders["Status"] && (
          <td>
            <div
              className={
                row?.Status?.toLowerCase() === "incomplete"
                  ? "badge badge-light-danger fw-bold"
                  : row?.Status?.toLowerCase() === "complete"
                  ? "badge badge-light-success fw-bold"
                  : "badge badge-light-primary fw-bold"
              }
            >
              {row?.Status}
            </div>
          </td>
        )}
        {chartHeaders["Milestone"] && (
          <td>
            <div
              className={
                row?.Milestone === "Ready to Code"
                  ? "badge bg-light-info text-info fw-bold"
                  : row?.Milestone === "Coding Done"
                  ? "badge badge-light-success fw-bold"
                  : row?.Milestone === "Ready to Audit" &&
                    auth.role === "Auditor"
                  ? "badge bg-light-info text-info fw-bold"
                  : row?.Milestone === "Ready to Audit"
                  ? "badge badge-light-primary fw-bold"
                  : "badge badge-light-success fw-bold"
              }
            >
              {row?.Milestone}
            </div>
          </td>
        )}
        {chartHeaders["qc_status"] && (
          <td>
            <div
              className={
                row?.qc_status?.toLowerCase() === "agree"
                  ? "badge badge-light-success fw-bold"
                  : row?.qc_status?.toLowerCase() === "feedback provided"
                  ? "badge badge-light-danger fw-bold"
                  : row?.qc_status?.toLowerCase() === "feedback rejected"
                  ? "badge badge-light-danger fw-bold"
                  : row?.Status?.toLowerCase() === "pass"
                  ? "badge badge-light-success fw-bold"
                  : "badge badge-light-primary fw-bold"
              }
            >
              {row?.qc_status}
            </div>
          </td>
        )}
        {chartHeaders["follow_up_auditor"] && (
          <td>
            {row?.follow_up_auditor?.id ? (
              <div className="symbol-group symbol-hover flex-nowrap">
                <OverlayTrigger
                  overlay={<Tooltip>{row?.follow_up_auditor?.name}</Tooltip>}
                  key={row?.follow_up_auditor?.id}
                  placement={"right"}
                >
                  <div
                    className="symbol symbol-35px symbol-circle user-image"
                    data-kt-initialized="1"
                  >
                    <img
                      alt="name"
                      src={
                        row?.follow_up_auditor?.image_url ??
                        `../assets/media/avatars/300-${imageIdGenerate(
                          row?.follow_up_auditor?.id,
                        )}.jpg`
                      }
                    />
                  </div>
                </OverlayTrigger>
              </div>
            ) : (
              ""
            )}
          </td>
        )}
        {chartHeaders["Process"] && <td>{row?.Process}</td>}
        {chartHeaders["ReceivedDate"] && <td>{row?.ReceivedDate}</td>}
        {chartHeaders["SubSpecialty"] && <td>{row?.SubSpecialty}</td>}
        {chartHeaders["date_of_coder_allocation"] && <td>{row?.date_of_coder_allocation}</td>}
        {chartHeaders["date_of_auditor_allocation"] && <td>{row?.date_of_auditor_allocation}</td>}
      </tr>
    ));
  };

  const handleLocationChange = (event) => {
    setDefaultLocation(event);
    triggerFilterOpen();
  };

  const handleSpecialityChange = (event) => {
    setDefaultSpeciality(event);
    triggerFilterOpen();
  };

  const handleSubSpecialityChange = (event) => {
    setDefaultSubSpeciality(event);
    triggerFilterOpen();
  };

  const handleMilestoneChange = (event) => {
    setDefaultMilestone(event);
    triggerFilterOpen();
  };

  const handleAuditorChange = (event) => {
    setDefaultAuditorFilter(event);
    triggerFilterOpen();
  };

  const handleOriginalAuditorChange = (event) => {
    setDefaultOriginalAuditorFilter(event);
    triggerFilterOpen();
  };

  const handleFollowUpAuditorChange = (event) => {
    setDefaultFollowUpAuditorFilter(event);
    triggerFilterOpen();
  };

  const handleProcessChange = (event) => {
    setDefaultProcess(event);
    triggerFilterOpen();
  };

  const handleChartStatusChange = (event) => {
    setDefaultChartStatus(event);
    triggerFilterOpen();
  };

  const handleQcStatusChange = (event) => {
    setDefaultQcStatus(event);
    triggerFilterOpen();
  };

  const handlePrimaryHealthChange = (event) => {
    setDefaultPrimaryHealth(event);
    triggerFilterOpen();
  };

  const handleFacilitiesChange = (event) => {
    setDefaultFacility(event);
    triggerFilterOpen();
  };

  const handleHoldReasonChange = (event) => {
    setDefaultHoldReason(event);
    triggerFilterOpen();
  };

  const handleAuditOptionsChange = (event) => {
    setDefaultAuditOptions(event);
    triggerFilterOpen();
  };

  const handleResponsibleParty = (event) => {
    setDefaultResponsibleParty(event);
    triggerFilterOpen();
  };
  const handleClientComment = (event) => {
    triggerFilterOpen();
    setCommentClient(event?.value);
  };
  const handleDenialComment = (event) => {
    triggerFilterOpen();
    setDenialComment(event?.value);
  };
  const handleDeficiencyComment = (event) => {
    triggerFilterOpen();
    setdeficiencyComment(event?.value);
  };

  const map = (data) => ({
    label: `${data.name}`,
    value: data.id,
  });

  useEffect(() => {
    if (
      localFilterData &&
      allSelectLoaded &&
      Object.keys(localFilterData).length > 0
    ) {
      const specialityValues = speciality
        ?.filter((data) => localFilterData.specialty?.includes(data.id))
        .map(map);
      setDefaultSpeciality(specialityValues);
      const primaryHealthValues = primaryHealth
        ?.filter((data) => localFilterData.primaryHealth?.includes(data.id))
        .map(map);
      setDefaultPrimaryHealth(primaryHealthValues);

      const FacilitiesValues = facility
        ?.filter((data) => localFilterData.facility?.includes(data.id))
        .map(map);
      setDefaultFacility(FacilitiesValues);
      const subSpecialityValues = subSpeciality
        ?.filter((data) => localFilterData.subSpecialty?.includes(data.id))
        .map(map);
      setDefaultSubSpeciality(subSpecialityValues);
      setSelectedOptionWorkListActual(localFilterData.actualWorkList);
      setSelectedOptionChartRender(localFilterData.chartRender);
      setSelectedOptionsChart((Array.isArray(localFilterData.chart_no) && localFilterData.chart_no[0]==='') ? "" : localFilterData.chart_no);
      const locationValues = location
        ?.filter((data) => localFilterData.location?.includes(data.id))
        .map(map);
      setDefaultLocation(locationValues);
      const processValues = process
        ?.filter((data) => localFilterData.processid?.includes(data.id))
        .map(map);
      setDefaultProcess(processValues);
      setDateOfService(localFilterData?.date_of_service);
      setReceivedDate(localFilterData?.received_date);
      setDateOfCompletion(localFilterData?.completion_date);
      const milestoneValues = milestone
        ?.filter((data) => localFilterData.milestone?.includes(data.id))
        .map(map);
      setDefaultMilestone(milestoneValues);
      const blankQcStatus = { id: 0, name: "Blank" };
      const modifiedQcStatus = [...qcStatus];
      modifiedQcStatus.push(blankQcStatus);
      const qcValues = modifiedQcStatus
        ?.filter((data) => localFilterData.qc_status_id?.includes(data.id))
        .map(map);
      setDefaultQcStatus(qcValues);
      const holdValues = holdReason
        ?.filter((data) => localFilterData.hold_reasons?.includes(data.id))
        .map(map);
      setDefaultHoldReason(holdValues);
      const auditValues = auditOption
        ?.filter((data) => localFilterData.audit_options?.includes(data.id))
        .map(map);
      setDefaultAuditOptions(auditValues);
      const orignalAuditorValues = auditorFilter
        ?.filter((data) => localFilterData.original_auditor?.includes(data.id))
        .map(map);
      setDefaultOriginalAuditorFilter(orignalAuditorValues);
      const followAuditorValues = auditorFilter
        ?.filter((data) => localFilterData.follow_up_auditor?.includes(data.id))
        .map(map);
      setDefaultFollowUpAuditorFilter(followAuditorValues);
      const auditorValues = auditorFilter
        ?.filter((data) => localFilterData.latest_auditor?.includes(data.id))
        .map(map);
      setDefaultAuditorFilter(auditorValues);
      const coderValues = coders
        ?.filter((data) => localFilterData.latest_coder?.includes(data.id))
        .map(map);
      setCoderFilter(coderValues);
      const orignalCoderValues = coders
        ?.filter((data) => localFilterData.original_coder?.includes(data.id))
        .map(map);
      setOriginalCoderFilter(orignalCoderValues);
      const followCoderValues = coders
        ?.filter((data) => localFilterData.follow_up_coder?.includes(data.id))
        .map(map);
      setFollowUpCoderFilter(followCoderValues);

      const allocatedUserValues = allUsers
        ?.filter((data) => localFilterData.UserId?.includes(data.id))
        .map((data) => ({
          label: `${data.first_name} ${data.last_name}`,
          value: data.id,
        }));
      setAllocatedUserfilter(allocatedUserValues);
      const chartStatusValues = chartStatus
        ?.filter((data) => localFilterData.chart_status?.includes(data.id))
        .map(map);
      setDefaultChartStatus(chartStatusValues);
      setCommentClient(localFilterData?.coder_comments);
      setDenialComment(localFilterData?.denialComment);
      setdeficiencyComment(localFilterData?.deficiencyComment);
      setSelectedOptionWorkList(localFilterData?.worklist_number);
      let filterObj = {
        ...inpval,
        date_of_service: dateOfService || "",
        received_date: receivedDate || "",
        completion_date: dateOfCompletion || "",
        location: localFilterData.location,
        processid: localFilterData.processid,
        specialty: localFilterData.specialty,
        facility: localFilterData.facility,
        primary_health: localFilterData.primaryHealth,
        milestone: localFilterData.milestone,
        latest_coder: localFilterData.latest_coder,
        latest_auditor: localFilterData.latest_auditor,
        coder_comments: localFilterData.coder_comments || "",
        denialComment: localFilterData.denialComment || "",
        deficiencyComment: localFilterData.deficiencyComment || "",
        qc_status_id: localFilterData.qc_status_id,
        chart_status: localFilterData.chart_status,
        audit_options: localFilterData.audit_options,
        hold_reasons: localFilterData.hold_reasons,
        s_no_from: localFilterData.s_no_from,
        s_no_to: localFilterData.s_no_to,
        worklist_number: localFilterData.worklist_number,
        chart_no: localFilterData.chart_no,
        original_coder: localFilterData.original_coder,
        follow_up_coder: localFilterData.follow_up_coder,
        original_auditor: localFilterData.original_auditor,
        follow_up_auditor: localFilterData?.follow_up_auditor,
        UserId: localFilterData?.UserId,
      };
      setFilObj(filterObj);
      // setFilterPagination(true);
      setFilterForToDoList(filterObj);
      setLocalDataLoaded(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [allSelectLoaded]);

  const changeWorkList = (selected) => {
    setSelectedOptionWorkListActual(selected);
    let localValues = localStorageStore.getFilterValues();
    localValues = localValues ? JSON.parse(localValues) : {};
    localValues.actualWorkList = selected;
    localStorageStore.setFilterValues(JSON.stringify(localValues));
    setSelectedOptionWorkList([selected[0]?.worklist_no]);
    if (selected?.length >= 1) {
      triggerFilterOpen();
    }
  };

  const handleWorkListForAddChart = (selected) => {
    setSelectedNewChartWorkListActual(selected);
    setSelectedOptionWorkList([selected[0]?.worklist_no]);
    if (selected?.length >= 1) {
      handleAddChartMenu();
    }

  };

  const handleWorkListNewChartSubmit = async () => {
    try {
      const response = await saveNewChartInWorkList(selectedNewChartWorkListActual);

      if (response?.success) {
        window.toastr.success("New chart added successfully.");
        handleLinkClick(response?.data);
      } else {
        window.toastr.error(response?.message);
      }
    } catch (error) {
      window.toastr.error(error?.message || "Unable to add new chart");
    } finally {
      setSelectedNewChartWorkListActual([]);
    }
  };
  const fetchMasterData = () => {
    getMasterData()
      .then((response) => {
        setProcess(response.data?.processes);
        setLocation(response.data?.locations);
        setMilestone(response.data?.milestones);
        setSpeciality(response.data?.specialties);
        setPrimaryHealth(response.data?.primary_health);
        setFacility(response.data?.facility);
        setAuditor(response.data?.auditors_active);
        setAuditorFilter(response.data?.auditors_all);
        setCoder(response.data?.coders_all);
        setPriorities(response.data?.priorities);
        setCoderAttending(response.data?.coders_active);
        setQcStatus(response.data?.qc_status);
        setChartStatus(response.data?.statuses_all);
        setHoldReason(response.data?.hold_reasons);
        setAuditOption(response.data?.audit_options);
        setResponsibleParties(response.data?.responsible_parties);
        setAllUsers(response.data?.allUsers);
        setSubSpeciality(response.data?.subSpecialties);
        setAllSelectLoaded(true);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const setcritical = () => {
    setCurrentPage(1);
    setpriority(critical);
    unCheck();
    let inputs = document.querySelector(".action-checkbox");
    inputs.checked = false;
  };

  const sethigh = () => {
    setCurrentPage(1);
    setpriority(high);
    unCheck();
    let inputs = document.querySelector(".action-checkbox");
    inputs.checked = false;
  };

  const setmedium = () => {
    setCurrentPage(1);
    setpriority(medium);
    unCheck();
    let inputs = document.querySelector(".action-checkbox");
    inputs.checked = false;
  };

  const setlow = () => {
    setCurrentPage(1);
    setpriority(low);
    unCheck();
    let inputs = document.querySelector(".action-checkbox");
    inputs.checked = false;
  };

  const setDone = () => {
    setpriority(done);
    setCurrentPage(1);
    unCheck();
    let inputs = document.querySelector(".action-checkbox");
    inputs.checked = false;
  };

  const handleResetFields = () => {
    document.getElementById("serial_from").value = "";
    document.getElementById("serial_to").value = "";
    document.getElementById("dateRangePickerDateOfService").value = "";
    document.getElementById("dateRangePickerReceiveDate").value = "";
    document.getElementById("dateRangePickerDateOfComplete").value = "";
    document.getElementById("dateRangePickerDateOfCoderAllocation").value = "";
    document.getElementById("dateRangePickerDateOfAuditorAllocation").value = "";
    setDateOfCoderAllocation("");
    setDateOfAuditorAllocation("");
    setSerialNumberFrom("");
    setSerialNumberTo("");
    setDefaultLocation([]);
    setDefaultMilestone([]);
    setDefaultProcess([]);
    setDefaultSpeciality([]);
    setDefaultFacility([]);
    setFacility([]);
    setDefaultPrimaryHealth([]);
    setPrimaryHealth([]);
    setCoderFilter([]);
    setOriginalCoderFilter([]);
    setFollowUpCoderFilter([]);
    setAllocatedUserfilter([]);
    setDefaultAuditorFilter([]);
    setDefaultOriginalAuditorFilter([]);
    setDefaultFollowUpAuditorFilter([]);
    setDateOfService([]);
    setReceivedDate([]);
    setDateOfCompletion([]);
    setDefaultChartStatus([]);
    setSubSpeciality([]);
    setResponsibleParties([]);
    setDefaultSubSpeciality([]);
    setDefaultQcStatus([]);
    setDefaultHoldReason([]);
    setDefaultAuditOptions([]);
    typeaheadRef.current.clear();
    typeheadRefChart.current.clear();
    setSelectedOptionWorkList([]);
    setSelectedOptionsChart("");
    setCommentClient(null);
    setDenialComment(null);
    setdeficiencyComment(null);
    setInputval({});
    setFilObj({});
    triggerFilterOpen();
    navigate(routeLocation.pathname, { state: null });
    setResetForm(true);
    const valerion_filter_values = {
      date_of_service: "",
      received_date: "",
      completion_date: "",
      location: "",
      processid: "",
      specialty: "",
      milestone: [""],
      latest_coder: "",
      latest_auditor: "",
      coder_comments: "",
      qc_status_id: "",
      chart_status: "",
      audit_options: "",
      hold_reasons: "",
      chart_no: [""],
      original_coder: "",
      follow_up_coder: "",
      UserId: "",
      original_auditor: "",
      follow_up_auditor: "",
      facility: "",
      primary_health: "",
    };

    localStorage.setItem(
      "valerion_filter_values",
      JSON.stringify(valerion_filter_values),
    );
  };
  const handleResetReallocation = () => {
    setAuditorSelected([]);
    setCoderSelected([]);
    setTimeout(() => {
      document.querySelector("button.reallocate-btn").dispatchEvent(
        new MouseEvent("click", {
          view: window,
          bubbles: true,
          cancelable: true,
          buttons: 1,
        }),
      );
    }, 10);
  };

  const renderLocation = () => {
    if( +auth.globalClientId?.value !== 0 ) {
      return location.filter((data) => data.ClientId === auth.globalClientId?.value).map((data) => ({
        label: data?.name,
        value: data?.id,
      }));
    }
    return location?.map((data) => ({
      label: data?.name,
      value: data?.id,
    }));
  };

  const renderSpeciality = () => {
    return speciality?.map((data) => ({
      label: data?.name,
      value: data?.id,
    }));
  };

  const renderSubSpeciality = () => {
    return subSpeciality?.map((data) => ({
      label: data?.name,
      value: data?.id,
    }));
  };

  const renderMilestone = () => {
    return milestone?.map((data) => ({
      label: data?.name,
      value: data?.id,
    }));
  };

  const renderProcess = () => {
    return process?.map((data) => ({
      label: data?.name,
      value: data?.id,
    }));
  };
  const renderFacilities = () => {
    return facility?.map((data) => ({
      label: data?.name,
      value: data?.id,
    }));
  };

  const renderPrimaryHealths = () => {
    return primaryHealth?.map((data) => ({
      label: data?.name,
      value: data?.id,
    }));
  };
  const renderChartStatus = () => {
    return chartStatus?.map((data) => ({
      label: data?.name,
      value: data?.id,
    }));
  };

  const renderQcStatus = () => {
    const qcStatusOptions = [
      {
        label: "Blank",
        value: 0,
      },
    ];

    qcStatus?.forEach((data) => {
      qcStatusOptions.push({
        label: data?.name,
        value: data?.id,
      });
    });

    return qcStatusOptions;
  };

  const renderHoldReason = () => {
    return holdReason?.map((data) => ({
      label: data?.name,
      value: data?.id,
    }));
  };

  const renderResponsibleParty = () => {
    return responsibleParties?.map((data) => ({
      label: data?.name,
      value: data?.id,
    }));
  };

  const renderAuditOptions = () => {
    return auditOption?.map((data) => ({
      label: data?.name,
      value: data?.id,
    }));
  };
  const renderCommentClient = [
    { value: "empty", label: "Empty" },
    { value: "not-empty", label: "Not empty" },
  ];

  const saveColumnValues = (columnData) => {
    setChartHeaders(columnData);
    localStorage.setItem("valerion_chart_headers", JSON.stringify(columnData));
  };

  useEffect(() => {
    if (selectedOptionChart?.length) {
      handleSearchChart(selectedOptionChart);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterForToDOList]);

  useEffect(() => {
    if (!resetForm) {
      setGlobalChartSearch({
        dateOfService: routeLocation?.state?.submitData?.date_of_service ?? "",
        receivedDate: routeLocation?.state?.submitData?.receivedDate ?? "",
        dateOfJoining: routeLocation?.state?.submitData?.completion_date ?? "",
        selectedOptionChart: routeLocation?.state?.submitData?.chart_no ?? "",
      });
      setDateOfService(routeLocation?.state?.submitData?.date_of_service ?? "");
      setReceivedDate(routeLocation?.state?.submitData?.receivedDate ?? "");
      setDateOfCompletion(
        routeLocation?.state?.submitData?.completion_date ?? "",
      );
      setSelectedOptionsChart(routeLocation?.state?.submitData?.chart_no ?? "");
    } else {
      setResetForm(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [routeLocation]);

  useEffect(() => {
    // filterSubmit("submit", true);
  }, [globalChartSearch]);

  const handleEventDateOfService = (event, picker) => {
    picker.element.val(
      picker.startDate.format("MM/DD/YYYY") +
        " - " +
        picker.endDate.format("MM/DD/YYYY"),
    );
    setDateOfService(
      picker.startDate.format("MM/DD/YYYY") +
        " - " +
        picker.endDate.format("MM/DD/YYYY"),
    );
  };

  const handleEventReceiveDate = (event, picker) => {
    picker.element.val(
      picker.startDate.format("MM/DD/YYYY") +
        " - " +
        picker.endDate.format("MM/DD/YYYY"),
    );
    setReceivedDate(
      picker.startDate.format("MM/DD/YYYY") +
        " - " +
        picker.endDate.format("MM/DD/YYYY"),
    );
  };
  const handleEventDateOfComplete = (event, picker) => {
    picker.element.val(
      picker.startDate.format("MM/DD/YYYY") +
        " - " +
        picker.endDate.format("MM/DD/YYYY"),
    );
    setDateOfCompletion(
      picker.startDate.format("MM/DD/YYYY") +
        " - " +
        picker.endDate.format("MM/DD/YYYY"),
    );
  };
  const handleCancelDateOfService = (event, picker) => {
    picker.element.val("");
    setDateOfService("");
  };
  const handleCancelReceiveDate = (event, picker) => {
    picker.element.val("");
    setReceivedDate("");
  };
  const handleCancelDateOfComp = (event, picker) => {
    picker.element.val("");
    setDateOfCompletion("");
  };

  const handleAddDateOfAllocation = (picker, type) => {
    if (type === 'coder') {
      picker.element.val(
        picker.startDate.format("MM/DD/YYYY") +
        " - " +
        picker.endDate.format("MM/DD/YYYY"),
      );
      setDateOfCoderAllocation(
        picker.startDate.format("MM/DD/YYYY") +
        " - " +
        picker.endDate.format("MM/DD/YYYY"),
      );
    }
    if (type === 'auditor') {
      picker.element.val(
        picker.startDate.format("MM/DD/YYYY") +
        " - " +
        picker.endDate.format("MM/DD/YYYY"),
      );
      setDateOfAuditorAllocation(
        picker.startDate.format("MM/DD/YYYY") +
        " - " +
        picker.endDate.format("MM/DD/YYYY"),
      );
    }
  };

  const handleCancelDateOfAllocation = (picker, type) => {
    if (type === 'coder') {
      picker.element.val("");
      setDateOfCoderAllocation("");
    }
    if (type === 'auditor') {
      picker.element.val("");
      setDateOfAuditorAllocation("");
    }
  };

  useEffect(() => {
    setKey((prevKey) => prevKey + 1);
  }, [selectedOptionChart]);

  const handlePageSizeUpdate = (e) => {
    setPageSize(e.value);
  };

  const pageSizeOptions = [
    { value: "10", label: "10" },
    { value: "25", label: "25" },
    { value: "50", label: "50" },
    { value: "75", label: "75" },
    { value: "100", label: "100" },
  ];

  const isNonCoderProfile =
    localStorage.Role === userRole.Manager ||
    localStorage.Role === userRole.Auditor ||
    localStorage.Role === userRole.TL;

  const conditionalClassName = isNonCoderProfile
    ? "menu menu-sub menu-sub-dropdown w-900px w-md-980px"
    : "menu menu-sub menu-sub-dropdown w-900px w-md-980px h-500px";

  let chartListViewDuration;

  // let initialSettings = {
  //   autoUpdateInput: false,
  //   locale: { cancelLabel: "Clear" },
  //   showDropdowns: true,
  // };

  if (isNonCoderProfile) {
    const userId = localStorageStore.getLoggedInUserId();
    const [foundUser] = allUsers.filter(
      (user) => user.id === parseInt(userId, 10),
    );
    chartListViewDuration = foundUser?.chart_list_view_duration_settings;
    // validFilterDateTo = moment().format("'MM/DD/YYYY'");
    // validFilterDateFrom = moment()
    //   .subtract(chartListViewDuration, "d")
    //   .format("'MM/DD/YYYY'");

    // initialSettings = {
    //   ...initialSettings,
    //   minDate: validFilterDateFrom,
    //   maxDate: validFilterDateTo,
    // };
  }

  const date = new Date();
  const maxDateOfService = `${
    date.getMonth() + 1
  }/${date.getDate()}/${date.getFullYear()}`;

  
  return (
    <>
      <div>
        <div className="d-flex justify-content-between progress-button">
          <div className="mb-4 ms-3">
            <h3 className="pb-0  pt-5">My To-do List </h3>
            <h5>
              {chartListViewDuration && isNonCoderProfile
                ? `The view contains chart/s ${
                    chartListViewDuration > 366
                      ? "since inception."
                      : `within last ${chartListViewDuration} days`
                  }`
                : null}
            </h5>
          </div>
        </div>

        <div className="card priority-card">
          <div className="card-header pt-7 border-bottom-0">
            <ul className="nav nav-tabs nav-line-tabs mb-5 fs-6" role="tablist">
              <li className="nav-item" role="presentation">
                <Link
                  className="nav-link active"
                  onClick={() => {
                    setcritical();
                  }}
                  data-bs-toggle="tab"
                  href="#kt_tab_pane_critical"
                  aria-selected="true"
                  role="tab"
                >
                  {" "}
                  Critical ({total?.Critical}){" "}
                </Link>
              </li>
              <li className="nav-item" role="presentation">
                <Link
                  className="nav-link"
                  data-bs-toggle="tab"
                  onClick={() => {
                    sethigh();
                  }}
                  href="#kt_tab_pane_medium"
                  aria-selected="false"
                  role="tab"
                  tabIndex={-1}
                >
                  {" "}
                  High ({total?.High}){" "}
                </Link>
              </li>
              <li className="nav-item" role="presentation">
                <Link
                  className="nav-link"
                  data-bs-toggle="tab"
                  onClick={() => {
                    setmedium();
                  }}
                  href="#kt_tab_pane_medium"
                  aria-selected="false"
                  role="tab"
                  tabIndex={-1}
                >
                  {" "}
                  Medium ({total?.Medium}){" "}
                </Link>
              </li>
              <li className="nav-item" role="presentation">
                <Link
                  className="nav-link"
                  data-bs-toggle="tab"
                  onClick={() => {
                    setlow();
                  }}
                  href="#kt_tab_pane_low"
                  aria-selected="false"
                  role="tab"
                  tabIndex={-1}
                >
                  {" "}
                  Low ({total?.Low}){" "}
                </Link>
              </li>
              <li className="nav-item" role="presentation">
                <Link
                  className="nav-link"
                  data-bs-toggle="tab"
                  onClick={() => {
                    setDone();
                  }}
                  href="#kt_tab_pane_low"
                  aria-selected="false"
                  role="tab"
                  tabIndex={-1}
                >
                  {auth.role === userRole.Coder ||
                  auth.role === userRole.Auditor
                    ? "Done"
                    : "Finalized"}{" "}
                  ({total?.done})
                </Link>
              </li>
            </ul>
            <div className="d-flex">
              <Select
                options={pageSizeOptions}
                value={pageSizeOptions.find(
                  (option) => option.value === pageSize,
                )}
                onChange={handlePageSizeUpdate}
                placeholder="Page Size"
                styles={{
                  control: (provided) => ({
                    ...provided,
                    height: "50px",
                    width: "90px",
                    justifyContent: "flex-end",
                  }),
                }}
              />
              <>
                <button
                  type="button"
                  id="chart_list_columns_button"
                  className="btn btn-light-primary ms-4 btn-column-filter"
                  data-bs-toggle="modal"
                  data-bs-target="#column-modifier"
                >
                  <i className="fa-solid fa-stairs"></i>
                  {" Columns"}
                </button>
                <ToDoColumnModifier
                  initialColumnValues={chartHeaders}
                  saveColumnValues={saveColumnValues}
                />
              </>
              <div>
                <button
                  type="button"
                  id="chart_list_filter_button"
                  className="btn btn-light-primary ms-4 btn-filter"
                  data-kt-menu-trigger="click"
                  data-kt-menu-placement="bottom-end"
                >
                  <i className="fas fa-filter"></i>
                  {" Filter"}
                </button>

                <div className={conditionalClassName} data-kt-menu="true">
                  <div className="px-7 py-4">
                    <div className="fs-5 text-dark fw-bold">Filter Options</div>
                  </div>

                  <div className="separator border-gray-200" />

                  <div
                    className="px-7 py-3 scroll-y chart-filter"
                    data-kt-user-table-filter="form"
                  >
                    <div className="row">
                      <div className="col-lg-3 col-12 mb-1">
                        <label className="form-label">Location </label>
                        <Select
                          options={renderLocation()}
                          isMulti={true}
                          value={defaultLocation}
                          onChange={handleLocationChange}
                          isDisabled={+auth.globalLocationId?.value !== 0}
                        />
                      </div>
                      <div className="col-lg-3 col-12 mb-1">
                        <div className="mb-1">
                          <label className="form-label">Worklist #</label>
                          <AsyncTypeahead
                            filterBy={() => true}
                            isLoading={isLoading}
                            id="worklistdata"
                            ignoreDiacritics={ignoreDiacritics}
                            labelKey="worklist_no"
                            placeholder="..."
                            options={optionsWorklist}
                            useCache={false}
                            debounceTime
                            minLength={1}
                            onSearch={handleSearchWorkList}
                            renderMenuItemChildren={(option) => (
                              <>
                                {" "}
                                <span>{option.worklist_no}</span>{" "}
                              </>
                            )}
                            selected={selectedOptionWorkListActual}
                            ref={typeaheadRef}
                            onChange={changeWorkList}
                          />
                        </div>
                      </div>
                      <div className="col-lg-3 col-12  mb-1">
                        <div className="mb-1">
                          <label className="form-label">S. No.</label>
                          <div className="row">
                            <div className="col-lg-6 col-6">
                              <input
                                className="form-control"
                                name="s_no_from"
                                type="number"
                                min={0}
                                placeholder="From"
                                value={serialNumberFrom}
                                onChange={(e) =>
                                  setSerialNumberFrom(e.target.value)
                                }
                                id="serial_from"
                              />
                            </div>
                            <div className="col-lg-6 col-6">
                              <input
                                className="form-control"
                                name="s_no_to"
                                type="number"
                                min={serialNumberFrom}
                                value={serialNumberTo}
                                placeholder="To"
                                onChange={(e) =>
                                  setSerialNumberTo(e.target.value)
                                }
                                id="serial_to"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-3 col-12 mb-1">
                        <label className="form-label">Allocated User </label>
                        <Select
                          options={renderAllocatedUserFilter()}
                          isMulti={true}
                          value={allocatedUserFilter}
                          onChange={handleAllocatedUserFilter}
                        />
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-lg-3 col-12 mb-1">
                        <div className="mb-1">
                          <label className="form-label">
                            Primary Speciality{" "}
                          </label>
                          <Select
                            options={renderSpeciality()}
                            isMulti={true}
                            value={defaultSpeciality}
                            onChange={handleSpecialityChange}
                          />
                        </div>
                      </div>
                      <div className="col-lg-3 col-12 mb-1">
                        <div className="mb-1">
                          <label className="form-label">Sub Speciality </label>
                          <Select
                            options={renderSubSpeciality()}
                            isMulti={true}
                            value={defaultSubSpeciality}
                            onChange={handleSubSpecialityChange}
                          />
                        </div>
                      </div>
                      <div className="col-lg-3 col-12 mb-1">
                        <div className="mb-1">
                          <label className="form-label">Chart #</label>
                          <AsyncTypeahead
                            filterBy={() => true}
                            isLoading={isLoading}
                            id="chartdata"
                            ignoreDiacritics={ignoreDiacritics}
                            labelKey="chart_no"
                            placeholder="..."
                            options={optionsChart}
                            ref={typeheadRefChart}
                            useCache={false}
                            debounceTime
                            onSearch={handleSearchChart}
                            selected={selectedOptionChartRender}
                            minLength={1}
                            onChange={(selected) => {
                              setSelectedOptionChartRender(selected);
                              let localValues =
                                localStorageStore.getFilterValues();
                              localValues = localValues
                                ? JSON.parse(localValues)
                                : {};
                              localValues.chartRender = selected;
                              localStorageStore.setFilterValues(
                                JSON.stringify(localValues),
                              );
                              setSelectedOptionChartRender(selected);
                              setSelectedOptionsChart(
                                selected[0]?.chart_no || "",
                              );
                              if (selected?.length >= 1) {
                                triggerFilterOpen();
                              }
                            }}
                          />
                        </div>
                      </div>
                      <div className="col-lg-3 col-6 mb-1">
                        <label className="form-label">
                          Primary Health Plan
                        </label>
                        <Select
                          options={renderPrimaryHealths()}
                          isMulti={true}
                          value={defaultPrimaryHealth}
                          onChange={handlePrimaryHealthChange}
                          menuPlacement="auto"
                        />
                      </div>
                      <div className="col-lg-3 col-12 mb-1">
                        <label className="form-label">Milestone </label>
                        <Select
                          options={renderMilestone()}
                          isMulti={true}
                          value={defaultMilestone}
                          onChange={handleMilestoneChange}
                        />
                      </div>
                      <div className="col-lg-3 col-12 mb-1">
                        <label className="form-label">Hold reason </label>
                        <Select
                          options={renderHoldReason()}
                          isMulti={true}
                          value={defaultHoldReason}
                          onChange={handleHoldReasonChange}
                        />
                      </div>
                      <div className="col-lg-3 col-6 mb-1">
                        <label className="form-label">Chart status </label>
                        <Select
                          options={renderChartStatus()}
                          isMulti={true}
                          value={defaultChartStatus}
                          onChange={handleChartStatusChange}
                          menuPlacement="auto"
                        />
                      </div>
                      <div className="col-lg-3 col-12 mb-1">
                        <label className="form-label">Facility </label>
                        <Select
                          id="facilityid"
                          options={renderFacilities()}
                          isMulti={true}
                          value={defaultFacility}
                          onChange={handleFacilitiesChange}
                        />
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-lg-3 col-12 mb-1">
                        <label className="form-label mb-1">
                          <span>Received Date</span>
                        </label>
                        <DateRangePicker
                          initialSettings={{
                            autoUpdateInput: false,
                            locale: { cancelLabel: "Clear" },
                            showDropdowns: true,
                          }}
                          onShow={() => {
                            setMenuStaticProperty(true);
                          }}
                          onHide={() => {
                            setMenuStaticProperty(false);
                          }}
                          onApply={handleEventReceiveDate}
                          style={{ zIndex: "20" }}
                          onCancel={handleCancelReceiveDate}
                        >
                          <input
                            type="text"
                            id="dateRangePickerReceiveDate"
                            defaultValue={receivedDate}
                            className="form-control"
                            placeholder="Select Date"
                            autoComplete="off"
                          />
                        </DateRangePicker>
                      </div>
                      <div className="col-lg-3 col-12 mb-1">
                        <label className="form-label mb-1">
                          <span>Date of completion</span>
                        </label>
                        <DateRangePicker
                          initialSettings={{
                            autoUpdateInput: false,
                            locale: { cancelLabel: "Clear" },
                            showDropdowns: true,
                          }}
                          onShow={() => {
                            setMenuStaticProperty(true);
                          }}
                          onHide={() => {
                            setMenuStaticProperty(false);
                          }}
                          onApply={handleEventDateOfComplete}
                          style={{ zIndex: "20" }}
                          onCancel={handleCancelDateOfComp}
                        >
                          <input
                            type="text"
                            id="dateRangePickerDateOfComplete"
                            defaultValue={dateOfCompletion}
                            className="form-control"
                            placeholder="Select Date"
                            autoComplete="off"
                          />
                        </DateRangePicker>
                      </div>

                      <div className="col-lg-3 col-12 mb-1">
                        <label className="form-label mb-1">
                          <span>Date of service</span>
                        </label>
                        <DateRangePicker
                          initialSettings={{
                            autoUpdateInput: false,
                            locale: { cancelLabel: "Clear" },
                            showDropdowns: true,
                            minDate: "01/01/2020",
                            maxDate: maxDateOfService,
                          }}
                          onShow={() => {
                            setMenuStaticProperty(true);
                          }}
                          onHide={() => {
                            setMenuStaticProperty(false);
                          }}
                          onApply={handleEventDateOfService}
                          style={{ zIndex: "20" }}
                          onCancel={handleCancelDateOfService}
                        >
                          <input
                            type="text"
                            id="dateRangePickerDateOfService"
                            defaultValue={dateOfService}
                            placeholder="Select Date"
                            autoComplete="off"
                            className="form-control"
                          />
                        </DateRangePicker>
                      </div>
                      <div className="col-lg-3 col-12 mb-1">
                        <label className="form-label">
                          Deficiency comments{" "}
                        </label>
                        <Select
                          options={renderCommentClient}
                          onChange={handleDeficiencyComment}
                          menuPlacement="auto"
                          value={renderCommentClient.find(
                            (option) => option.value === commentClient,
                          )}
                        />
                      </div>
                    </div>
                    <div className="row mb-1">
                      <div className="col-lg-3 col-6 mb-1">
                        <label className="form-label">QC status </label>
                        <Select
                          options={renderQcStatus()}
                          isMulti={true}
                          value={defaultQcStatus}
                          onChange={handleQcStatusChange}
                          menuPlacement="auto"
                        />
                      </div>

                      <div className="col-lg-3 col-12 mb-1">
                        <label className="form-label">Process </label>
                        <Select
                          id="processid"
                          options={renderProcess()}
                          isMulti={true}
                          value={defaultProcess}
                          onChange={handleProcessChange}
                          isDisabled={auth.globalLocationId?.value ? ( auth.globalLocationId.value.startsWith('process_') ? true : false ): false}
                        />
                      </div>
                      <div className="col-lg-3 col-12 mb-1">
                        <label className="form-label">
                          Comments to client{" "}
                        </label>
                        <Select
                          options={renderCommentClient}
                          onChange={handleClientComment}
                          menuPlacement="auto"
                          value={renderCommentClient.find(
                            (option) => option.value === commentClient,
                          )}
                        />
                      </div>
                      <div className="col-lg-3 col-12 mb-1">
                        <label className="form-label">Audit options</label>
                        <Select
                          options={renderAuditOptions()}
                          isMulti={true}
                          value={defaultAuditOptions}
                          onChange={handleAuditOptionsChange}
                          menuPlacement="auto"
                        />
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-lg-3 col-12 mb-1">
                        <label className="form-label">Responsible Party</label>
                        <Select
                          options={renderResponsibleParty()}
                          isMulti={true}
                          value={defaultResponsibleParty}
                          onChange={handleResponsibleParty}
                          menuPlacement="auto"
                        />
                      </div>
                      <div className="col-lg-3 col-12 mb-1">
                        <label className="form-label">Denial comments </label>
                        <Select
                          options={renderCommentClient}
                          onChange={handleDenialComment}
                          menuPlacement="auto"
                          value={renderCommentClient.find(
                            (option) => option.value === commentClient,
                          )}
                        />
                      </div>
                      {isNonCoderProfile && (
                        <>
                          <div className="col-lg-3 col-12 mb-1">
                            <label className="form-label">Latest Coder </label>
                            <Select
                              options={renderCoderFilter()}
                              isMulti={true}
                              value={coderFilter}
                              onChange={handleCoderFilter}
                              menuPlacement="auto"
                            />
                          </div>

                          <div className="col-lg-3 col-12 mb-1">
                            <label className="form-label">
                              Original Coder{" "}
                            </label>
                            <Select
                              options={renderCoderFilter()}
                              isMulti={true}
                              value={originalCoderFilter}
                              onChange={handleOriginalCoderFilter}
                              menuPlacement="auto"
                            />
                          </div>
                        </>
                      )}
                    </div>

                    <div className="row">
                      {isNonCoderProfile && (
                        <>
                          <div className="col-lg-3 col-12 mb-1">
                            <label className="form-label">
                              Follow Up Coder{" "}
                            </label>
                            <Select
                              options={renderCoderFilter()}
                              isMulti={true}
                              value={followUpCoderFilter}
                              onChange={handleFollowUpCoderFilter}
                              menuPlacement="auto"
                            />
                          </div>
                          <div className="col-lg-3 col-12 mb-1">
                            <label className="form-label mb-1">
                              Latest Auditor
                            </label>
                            <Select
                              options={renderAuditorFilterList()}
                              isMulti={true}
                              value={defaultAuditorFilter}
                              onChange={handleAuditorChange}
                              menuPlacement="auto"
                            />
                          </div>

                          <div className="col-lg-3 col-12 mb-1">
                            <label className="form-label mb-1">
                              Original Auditor
                            </label>
                            <Select
                              options={renderAuditorFilterList()}
                              isMulti={true}
                              value={originalAuditorFilter}
                              onChange={handleOriginalAuditorChange}
                              menuPlacement="auto"
                            />
                          </div>

                          <div className="col-lg-3 col-12 mb-1">
                            <label className="form-label mb-1">
                              Follow Up Auditor
                            </label>
                            <Select
                              options={renderAuditorFilterList()}
                              isMulti={true}
                              value={fllowUpAuditorFilter}
                              onChange={handleFollowUpAuditorChange}
                              menuPlacement="auto"
                            />
                          </div>
                        </>
                      )}

                      <div className="col-lg-3 col-12 mb-1">
                        <label className="form-label mb-1">
                          <span>Date of Coder Allocation</span>
                        </label>
                        <DateRangePicker
                          initialSettings={{
                            autoUpdateInput: false,
                            locale: { cancelLabel: "Clear" },
                            showDropdowns: true,
                          }}
                          onShow={() => {
                            setMenuStaticProperty(true);
                          }}
                          onHide={() => {
                            setMenuStaticProperty(false);
                          }}
                          onApply={(e, picker) => handleAddDateOfAllocation(picker, 'coder')}
                          style={{ zIndex: "20" }}
                          onCancel={(e, picker) => handleCancelDateOfAllocation(picker, 'coder')}
                        >
                          <input
                            type="text"
                            id="dateRangePickerDateOfCoderAllocation"
                            defaultValue={dateOfCoderAllocation}
                            className="form-control"
                            placeholder="Select Date"
                            autoComplete="off"
                          />
                        </DateRangePicker>
                      </div>

                      <div className="col-lg-3 col-12 mb-1">
                        <label className="form-label mb-1">
                          <span>Date of Auditor Allocation</span>
                        </label>
                        <DateRangePicker
                          initialSettings={{
                            autoUpdateInput: false,
                            locale: { cancelLabel: "Clear" },
                            showDropdowns: true,
                          }}
                          onShow={() => {
                            setMenuStaticProperty(true);
                          }}
                          onHide={() => {
                            setMenuStaticProperty(false);
                          }}
                          onApply={(e, picker) => handleAddDateOfAllocation(picker, 'auditor')}
                          style={{ zIndex: "20" }}
                          onCancel={(e, picker) => handleCancelDateOfAllocation(picker, 'auditor')}
                        >
                          <input
                            type="text"
                            id="dateRangePickerDateOfAuditorAllocation"
                            defaultValue={dateOfAuditorAllocation}
                            className="form-control"
                            placeholder="Select Date"
                            autoComplete="off"
                          />
                        </DateRangePicker>
                      </div>
                    </div>
                    <div className="d-flex justify-content-end">
                      <button
                        type="reset"
                        className="btn btn-sm btn-light btn-active-light-primary me-2"
                        data-kt-menu-dismiss="true"
                        onClick={() => {
                          filterSubmit("reset");
                          handleResetFields();
                        }}
                      >
                        Reset
                      </button>
                      <button
                        type="submit"
                        onClick={() => filterSubmit("apply")}
                        className="btn btn-sm btn-primary"
                        data-kt-menu-dismiss="true"
                      >
                        Apply
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              {localStorage.Role === userRole.Coder && (
                <>
                  <button
                    type="button"
                    className="btn btn-primary ms-4 reallocate-btn"
                    data-kt-menu-trigger="click"
                    data-kt-menu-placement="bottom-end"
                  >
                    {" "}
                    <i className="fas fa-user-cog"></i> Reallocation{" "}
                  </button>
                  <div
                    className="menu menu-sub menu-sub-dropdown w-350px w-md-350px"
                    data-kt-menu="true"
                  >
                    <div className="d-flex justify-content-between  px-7 py-5">
                      <div className="fs-5 text-dark fw-bold">Reallocation</div>
                    </div>
                    <div className="separator border-gray-200"></div>
                    <div
                      className="px-7 pt-10 "
                      data-kt-user-table-filter="form"
                    >
                      <div className="col-12">
                        <div className="mb-4">
                          <div>
                            <label className="form-check-label">
                              Reallocation to Auditor
                            </label>
                            <br />
                            <Select
                              id="auditor_allocate"
                              options={renderAuditorList()}
                              name="AuditorId"
                              value={auditorSelected}
                              onChange={handleAllocateAuditor}
                              menuPlacement="auto"
                            ></Select>
                          </div>
                        </div>
                      </div>
                      <div className="d-flex justify-content-end pb-5">
                        <button
                          type="reset"
                          className="btn btn-sm btn-light btn-active-light-primary me-2"
                          data-kt-menu-dismiss="true"
                          onClick={handleResetReallocation}
                        >
                          Reset
                        </button>
                        <button
                          className="btn btn-sm btn-primary"
                          onClick={handleReallocateClick}
                          data-kt-menu-dismiss="true"
                        >
                          Apply
                        </button>
                      </div>
                    </div>
                  </div>
                </>
              )}
              {(localStorage?.Role === userRole.Manager ||
                localStorage?.Role === userRole.TL) && (
                <>
                  <button
                    type="button"
                    className="btn btn-primary ms-4 modify-btn"
                    data-kt-menu-trigger="click"
                    data-kt-menu-placement="bottom-end"
                  >
                    {" "}
                    <i className="fas fa-edit"></i> Modify Charts{" "}
                  </button>
                  <div
                    className="menu menu-sub menu-sub-dropdown w-400px w-md-400px"
                    data-kt-menu="true"
                  >
                    <div className="d-flex justify-content-between  px-7 py-5">
                      <div className="fs-5 text-dark fw-bold">
                        Modify Charts
                      </div>
                      <span className="badge badge-lg badge-light-success fw-bold my-0 selected-charts-count">
                        0 Selected
                      </span>
                      <div>
                        <button
                        type="submit"
                        className="btn btn-danger" style={{padding: '5px 10px'}}
                        data-kt-menu-dismiss="true"
                        onClick={() => deleteSelectedCharts()}
                        title="Delete Chart(s)"
                      >
                        <i className="fas fa-trash" style={{padding: 0,margin: 0,fontSize: '16px'}}></i> 
                      </button>
                    </div>
                    </div>
                    <div className="separator border-gray-200"></div>
                    <div className="px-7 py-5" data-kt-user-table-filter="form">
                      <div className="row">
                        <div className="col-12">
                          <div className="mb-4">
                            <label className="form-label">
                              Change priority{" "}
                            </label>
                            <select
                              className="form-select mb-2"
                              data-control="select2"
                              data-hide-search="true"
                              data-placeholder="..."
                              onChange={(event) => {
                                setAllocationPriority(event.target.value);
                              }}
                              id="allocationpriority"
                            >
                              <option value="">---</option>
                              {priorities?.map((option) => (
                                <option key={option?.id} value={option?.id}>
                                  {option?.name}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>
                        <div className="col-12">
                          <label className="form-label">
                            Change allocation{" "}
                          </label>
                        </div>
                        <div className="col-12">
                          <div className="mb-4">
                            <div className="form-check form-check-custom form-check-solid">
                              <input
                                className="form-check-input"
                                type="radio"
                                value=""
                                id="flexRadioDefault1"
                                name="allocation"
                                onClick={() => handleRadioCoder()}
                              />
                              <label
                                className="form-check-label"
                                htmlFor="flexRadioDefault1"
                                style={{ width: "-webkit-fill-available" }}
                              >
                                Allocate for Coding
                              </label>
                              <div style={{ width: "-webkit-fill-available" }}>
                                <Select
                                  options={renderCoderFilter()}
                                  onChange={handleReallocateCoder}
                                  isDisabled={coderDisabled}
                                  value={codersSelected}
                                  menuPlacement="auto"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-12">
                          <div className="mb-4">
                            <div className="form-check form-check-custom form-check-solid">
                              <input
                                className="form-check-input"
                                type="radio"
                                value=""
                                id="flexRadioDefault2"
                                name="allocation"
                                onClick={() => handleRadioAuditor()}
                              />
                              <label
                                className="form-check-label"
                                htmlFor="flexRadioDefault2"
                                style={{ width: "-webkit-fill-available" }}
                              >
                                Allocate for Auditing
                              </label>
                              <div style={{ width: "-webkit-fill-available" }}>
                                <Select
                                  options={renderAuditorList()}
                                  onChange={handleAllocateToAuditor}
                                  isDisabled={auditorDisabled}
                                  value={auditorSelected}
                                  menuPlacement="auto"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-12">
                          <div className="mb-4">
                            <div className="form-check form-check-custom form-check-solid">
                              <input
                                className="form-check-input"
                                type="radio"
                                value=""
                                id="flexRadioDefault3"
                                name="allocation"
                                onClick={handleRadioOriginalCoder}
                              />
                              <label
                                className="form-check-label"
                                htmlFor="flexRadioDefault3"
                                style={{ width: "-webkit-fill-available" }}
                              >
                                Reallocate to original Coder
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="d-flex justify-content-end">
                        <button
                          type="reset"
                          className="btn btn-sm btn-light btn-active-light-primary me-2"
                          data-kt-menu-dismiss="true"
                          onClick={reallocateSelectedChartsReset}
                        >
                          Reset
                        </button>
                        <button
                          type="submit"
                          className="btn btn-sm btn-primary"
                          data-kt-menu-dismiss="true"
                          onClick={() => reallocateSelectedCharts()}
                        >
                          Apply
                        </button>
                      </div>
                    </div>
                  </div>
                </>
              )}

              {(localStorage?.Role === userRole.Manager ||
                localStorage?.Role === userRole.TL) && (
                <div>
                  <button
                    type="button"
                    className="btn btn-primary ms-4 reallocate-btn"
                    data-kt-menu-trigger="click"
                    data-kt-menu-placement="bottom-end"
                  >
                    <i className="fas fa-user-clock"></i>
                    Self Allocation
                  </button>
                  <div
                    className="menu menu-sub menu-sub-dropdown w-350px w-md-350px"
                    data-kt-menu="true"
                    style={{
                      zIndex: 107,
                      position: "fixed",
                      inset: "0px 0px auto auto",
                      margin: 0,
                      transform: "translate3d(-59.6364px, 29.0909px, 0px)",
                    }}
                    data-popper-placement="bottom-end"
                  >
                    <div className="separator border-gray-200" />
                    <div
                      className="px-4 pt-10 text-center "
                      data-kt-user-table-filter="form"
                    >
                      <span className="badge badge-lg badge-light-success fw-bold my-0 selected-charts-count">
                        0 Selected
                      </span>
                      <p className="pb-10 fs-4">
                        Do you want to allocate the selected charts to yourself?
                      </p>
                      <div className="pb-4">
                        <button
                          type="reset"
                          className="btn btn-sm btn-light btn-active-light-primary me-2"
                          data-kt-menu-dismiss="true"
                        >
                          No
                        </button>
                        <button
                          type="submit"
                          className="btn btn-sm btn-primary"
                          onClick={handleSelfAllocatedChart}
                          data-kt-menu-dismiss="true"
                        >
                          Yes
                        </button>{" "}
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {localStorage?.Role === userRole.Auditor && (
                <div>
                  <button
                    type="button"
                    className="btn btn-primary ms-4 reallocate-btn"
                    data-kt-menu-trigger="click"
                    data-kt-menu-placement="bottom-end"
                  >
                    <i className="fas fa-user-clock"></i>
                    Allocation
                  </button>
                  <div
                    className="menu menu-sub menu-sub-dropdown w-350px w-md-350px"
                    data-kt-menu="true"
                    style={{
                      zIndex: 107,
                      position: "fixed",
                      inset: "0px 0px auto auto",
                      margin: 0,
                      transform: "translate3d(-59.6364px, 29.0909px, 0px)",
                    }}
                    data-popper-placement="bottom-end"
                  >
                    <div className="separator border-gray-200" />
                    <div
                      className="px-7 pt-10 text-center "
                      data-kt-user-table-filter="form"
                    >
                      <p className="badge badge-lg badge-light-success fw-bold my-0 selected-charts-count">
                        0 Selected
                      </p>
                      <p className="pb-5 fs-4">
                        Do you want to allocate the selected charts to yourself?
                      </p>
                      {/* <div className="d-flex justify-content-center border-top py-4"> */}
                      <button
                        type="reset"
                        className="btn btn-sm btn-light btn-active-light-primary me-2"
                        data-kt-menu-dismiss="true"
                      >
                        No
                      </button>
                      <button
                        type="submit"
                        className="btn btn-sm btn-primary"
                        onClick={handleSelfAllocatedChart}
                        data-kt-menu-dismiss="true"
                      >
                        Yes
                      </button>
                      {/* </div> */}
                    </div>
                    <hr />
                    <div
                      className="px-7 pt-10"
                      data-kt-user-table-filter="form"
                    >
                      <div className="col-12">
                        <div className="mb-4">
                          <div>
                            <label className="form-check-label">
                              Reallocation to Coder
                            </label>
                            <br />
                            <Select
                              id="coder_allocate"
                              options={renderCoderList()}
                              name="CoderId"
                              value={coderSelected}
                              onChange={handleAllocateCoder}
                              menuPlacement="auto"
                            ></Select>
                          </div>
                        </div>
                      </div>

                      <div className="d-flex justify-content-center border-top py-4">
                        <button
                          type="reset"
                          className="btn btn-sm btn-light btn-active-light-primary me-2"
                          data-kt-menu-dismiss="true"
                          onClick={handleResetReallocation}
                        >
                          Reset
                        </button>
                        <button
                          className="btn btn-sm btn-primary"
                          onClick={handleReallocateCoderClick}
                          data-kt-menu-dismiss="true"
                        >
                          Apply
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {(localStorage?.Role === userRole.Coder) && (
                <div className="d-flex align-items-start flex-column ms-4">
                  <button
                    type="button"
                    className="btn btn-primary add-btn mb-2"
                    data-kt-menu-trigger="click"
                    data-kt-menu-placement="bottom-end"
                  >
                    <i className="fas fa-add"></i> Add Chart
                  </button>
                  <div
                    className="menu menu-sub menu-sub-dropdown w-100 w-md-400px"
                    data-kt-menu="true"
                  >
                    <div className="d-flex justify-content-between align-items-center px-4 py-3">
                      <div className="fs-5 text-dark fw-bold">Add Chart</div>
                    </div>
                    <div className="separator border-gray-200"></div>
                    <div className="px-4 py-3">
                      <div className="mb-3">
                        <label className="form-label">Worklist #</label>
                        <AsyncTypeahead
                          filterBy={() => true}
                          isLoading={isLoading}
                          id="worklistdata"
                          ignoreDiacritics={ignoreDiacritics}
                          labelKey="worklist_no"
                          placeholder="..."
                          options={optionsWorklist}
                          useCache={false}
                          debounceTime
                          minLength={1}
                          onSearch={handleSearchWorkList}
                          renderMenuItemChildren={(option) => (
                            <span>{option.worklist_no}</span>
                          )}
                          selected={selectedNewChartWorkListActual}
                          ref={typeaheadRef}
                          onChange={handleWorkListForAddChart}
                        />
                      </div>
                    </div>

                    <div className="d-flex justify-content-end py-2 px-2">
                      <button
                        type="submit"
                        className="btn btn-sm btn-primary"
                        data-kt-menu-dismiss="true"
                        onClick={handleWorkListNewChartSubmit}
                      >
                        Add & Allocate
                      </button>
                     </div>
                  </div>
                </div>
              )}

            </div>
          </div>
          <div className="card-body  py-2">
            <div>
              <div className="separator separator-dashed my-5 mt-0" />
              <div className="tab-content" id="myTabContent">
                <div
                  className="tab-pane fade show active"
                  id="kt_tab_pane_critical"
                  role="tabpanel"
                >
                  <div className="table-responsive">
                    <table
                      className="table align-middle table-row-dashed fs-6 gy-5"
                      id="kt_table_todo_list"
                    >
                      <thead>
                        <tr className="text-start text-dark fw-bold fs-7 text-uppercase gs-0">
                          <th className="min-w-30px">
                            <div className="form-check form-check-sm form-check-custom form-check-solid me-3">
                              <input
                                className="form-check-input action-checkbox"
                                type="checkbox"
                                onChange={handleCheckBoxChange}
                                data-kt-check="true"
                                data-kt-check-target="#kt_table_todo_list .form-check-input"
                                value="1"
                              />
                            </div>
                          </th>
                          <th
                            onClick={() => {
                              toggleSort("Worklist");
                            }}
                          >
                            Worklist #{" "}
                            <i className={renderSortIcon("Worklist")}></i>{" "}
                          </th>
                          <th
                            onClick={() => {
                              toggleSort("Worklist");
                            }}
                          >
                            S. No.{" "}
                            <i className={renderSortIcon("Worklist")}></i>
                          </th>
                          {chartHeaders["Client"] && <th>Client</th>}
                          {chartHeaders["Location"] && <th>Location</th>}
                          {chartHeaders["Specialty"] && (
                            <th>Primary Speciality </th>
                          )}
                          {chartHeaders["chart_no"] && <th> Chart # </th>}
                          {chartHeaders["DateOfService"] && (
                            <th> Date of Service </th>
                          )}
                          {chartHeaders["original_coder"] && (
                            <th>Original Coder</th>
                          )}
                          {chartHeaders["follow_up_coder"] && (
                            <th>Follow Up Coder</th>
                          )}
                          {chartHeaders["original_auditor"] && (
                            <th>Original Auditor</th>
                          )}
                          {chartHeaders["UserId"] && <th> Allocated User</th>}
                          {chartHeaders["Status"] && <th> Chart Status</th>}
                          {chartHeaders["Milestone"] && <th> Milestone</th>}
                          {chartHeaders["qc_status"] && <th> QC status</th>}
                          {chartHeaders["follow_up_auditor"] && (
                            <th>Follow Up Auditor</th>
                          )}
                          {chartHeaders["Process"] && <th> Process</th>}
                          {chartHeaders["ReceivedDate"] && (
                            <th> Received Date </th>
                          )}
                          {chartHeaders["SubSpecialty"] && (
                            <th> Sub Specialty </th>
                          )}

                          {chartHeaders["date_of_coder_allocation"] && <th>Date of Coder Allocation</th>}
                          {chartHeaders["date_of_auditor_allocation"] && <th>Date of Auditor Allocation</th>}
                        </tr>
                      </thead>
                      <tbody className="text-gray-600 fw-semibold w-100 align-middle text-center">
                        {loader || !localDataLoaded ? (
                          <>
                          <tr>
                            <td key={"key1"}></td>
                              <td key={"key2"}></td>
                            {Object.values(chartHeaders).length ?
                              Object.values(chartHeaders)
                                .filter(Boolean)
                                .map((element, idx, self) => {
                                  if (idx === parseInt(self.length / 2, 10)) {
                                    return (
                                      <td key={`charts-${idx}`}>
                                        <span className="spinner-border h-50px w-50px text-gray-400" />
                                      </td>
                                    );
                                  }
                                  return <td key={`charts-${idx}`}></td>;
                                }) : null}
                          </tr>
                          </>
                        ) : (
                          <>{chartData && showTable(priority)}</>
                        )}
                      </tbody>
                    </table>
                    {loader === false && noData === true && (
                      <div>No Records Found ...</div>
                    )}
                    {noData === false && (
                      <CustomPagination
                        dataPerPage={pageSize}
                        totalData={
                          priority === done
                            ? total?.["done"]
                            : total?.[priority]
                        }
                        paginate={paginate}
                        currentPage={currentPage}
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default ToDoList;
